module.exports = __webpack_public_path__ + "static/media/master-card.8e1db203.svg";